// APEX Components - Migrated from @por/apex NPM package
// Main barrel export file

// Button
export { ApxButtonModule, ApxButtonComponent } from './lib/button/button.component.module';

// Input
export { ApxInputModule, ApxInputDirective, ApxInputGroupComponent, ApxPrefixDirective, ApxSuffixDirective } from './lib/input/input.component.module';

// Forms (ONLY module renamed to avoid Angular collision)
export { PorFormsModule, ApxFormFieldComponent, ApxFormGroupDirective } from './lib/form/form.module';

// Radio
export { ApxRadioModule, ApxRadioGroupComponent, ApxRadioButtonComponent } from './lib/radio-group/radio.module';

// Checkbox
export { ApxCheckboxModule, ApxCheckboxComponent } from './lib/checkbox/checkbox.module';

// Dropdown
export { ApxDropdownModule, ApxDropdownComponent, ApxDropdownOptionComponent, ApxDropdownOptionItemComponent } from './lib/dropdown/dropdown.module';

// Tabs
export { ApxTabsModule, ApxTabGroupComponent, ApxTabComponent } from './lib/tab-group/tabs.module';

// Overlay
export { ApxOverlayModule } from './lib/utils/overlay/overlay.module';

// Services
export { ControlErrorMessageService } from './lib/services/control-error-message.service';
export { DomEventService } from './lib/services/dom-event.service';

// Models
export * from './lib/models/change.model';
export * from './lib/models/dictionary.model';
export * from './lib/models/error.model';
